// 之前的样式的组件
// import MainPage from '../mainpage/mainpage.vue'

import MainPage from '../../components/mainpage/mainpage.vue'

export default {
    props: ['titleText'],
    data() {
        return {
            //协议弹出框
            outerVisible: false,
            //手机号登录默认变量
            activeName: 'first',
            //获取手机验证码返回的guid
            guid: '',
            //用来判断弹出的登录注册框=>登录/注册
            isEnter: true,
            //搜索课程的字符串
            classSreach: '',
            //登录提示
            loginMessage: '',
            //是否需要登录提示
            isLoginMessage: false,
            //身份证登录提示
            loginMessage1: '',
            //身份证是否需要登录提示
            isLoginMessage1: false,
            //登录号登录提示
            loginMessage2: '',
            //登录号是否需要登录提示
            isLoginMessage2: false,
            //登录手机号
            loginPhone: '',
            //登录身份证号
            loginIdentity: '',
            //登录登录名
            loginName: '',
            //登录密码
            loginPassword: '',
            //注册提示
            registerMessage: '',
            //是否需要注册提示
            isRegisterMessage: false,
            //注册手机号
            registerPhone: '',
            //注册验证码
            registerCode: '',
            //注册密码
            registerPassword: '',
            //注册密码
            registerCompany: '',
            //注册省
            registerProvince: '河南省',
            //注册市
            registerCity: '',
            //注册性别
            registerGender: '',
            //注册姓名
            registerName: '',
            //确认注册密码
            registerAffirmPassword: '',
            //身份证号码
            idcard: '',
            //获取验证码文字
            verificationText: '获取验证码',
            //用来存储多级标签
            labels: {
                id: '0'
            },
            //传标签JSON，但是没有除开一级标签
            labelsNoFirst: [],
            //同意协议
            agreeDoc: '',
            // 是否需要购物车
            is_project: '',
            // 店铺id
            shopId: '',
            // 公司所属地区
            companyTerritory: [
                '郑州市', '开封市', '洛阳市', '平顶山市', '安阳市', '鹤壁市', '新乡市', '焦作市', '济源市', '濮阳市', '许昌市', '漯河市', '三门峡市', '南阳市',
                '商丘市', '信阳市',
                '周口市', '驻马店市'
            ],
            //性别
            gender: ['男', '女'],
            click: 0
        }
    },
    methods: {
        //点击导航栏登录/注册切换弹出的登录/注册
        displayEnter: function(val) {
            this.isEnter = val;
        },
        // enter键登录
        loginKeyDown: function(e) {
            if (e.key === 'Enter') {
                this.login();
            }
        },
        // enter身份证登录按键
        loginKeyDown1: function(e) {
            if (e.key === 'Enter') {
                this.login1();
            }
        },
        // enter键注册
        registerKeyDown: function(e) {
            if (e.key === 'Enter') {
                this.register();
            }
        },
        //enter键搜索课程
        searchKeyDown: function(e) {
            if (e.key === 'Enter') {
                this.toProductList();
            }
        },
        //切换登录/注册
        switchEnter: function() {
            this.isEnter = !this.isEnter;
        },
        //获取当前路由的path
        getRouterPath() {
            //获取当前网址
            let arr = window.location.href.split('/');
            //分割成数组并取最后一个
            let str = arr[arr.length - 1];
            //定义path
            let path = "";
            //若str为空，则肯定是首页
            if (str == "") {
                path = "/"
            } else {
                //不为空则再判断是否有?传参，有则去掉传参的字符，无则直接获取
                str.indexOf("?") == -1 ? path = str : path = str.split("?")[0];
            }
            return path;
        },
        //课程搜索
        toProductList: function() {
            this.$router.push({
                path: '/blank',
                query: {
                    data: this.classSreach,
                    value: 'classtext',
                }
            });
        },
        //跳转首页
        goIndex: function() {
            if (this.shopId == 107) {
                window.location.href = 'http://www.zzrc.cn';
            } else if (this.shopId == 110) {
                window.location.href = 'http://www.zzzjedu.com';
            } else {
                this.$router.push({
                    path: '/'
                });
            }

        },
        //跳转个人中心
        toCenter: function() {
            // let address=
            this.$router.push({
                path: '/personalcenter'
            });
            // window.open(address.href,'_blank');
        },
        //跳转购物车
        toShoppingCart: function() {
            this.$router.push({
                path: '/shoppingcart'
            })
        },
        //全部课程跳转
        allClass: function() {
            this.$router.push({
                path: '/blank',
                query: {
                    zerotId: 0,
                    lableType: 'zeroLable',
                }
            })
        },
        //推荐课程
        recommendClass: function() {
            this.$router.push({
                path: '/blank',
                query: {
                    firstId: 31,
                    secondId: 12,
                    lableType: 'secondLable'

                }
            });
        },
        //继续教育课程
        continuingEducation: function() {
            this.$router.push({
                path: '/blank',
                query: {
                    firstId: 31,
                    lableType: 'firstLable',
                }
            });
        },
        //登录
        login: function() {
            let reg = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
            let me = this;
            if (!me.loginPhone.trim()) {
                me.loginMessage = '手机号不能为空';
                me.isLoginMessage = true;
            } else if (!reg.test(me.loginPhone)) {
                me.loginMessage = '手机号格式错误';
                me.isLoginMessage = true;
            } else if (!me.loginPassword.trim()) {
                me.loginMessage = '密码不能为空';
                me.isLoginMessage = true;
            } else {
                // 存储用户密码
                sessionStorage.setItem('password', me.loginPassword);

                let obj = {
                    phone: me.loginPhone,
                    password: me.loginPassword,
                    shop_id: this.shopId
                }
                me.$post('users/login_by_phone', obj).then(res => {
                    if (res.data.result) {
                        me.$store.state.id = res.data.result.token;
                        me.$store.state.shopId = res.data.result.shop_id
                        let model = document.querySelector('#modal-center');
                        UIkit.modal(model).hide();
                        this.$post('users/profile', {
                            token: this.$store.state.id
                        }).then(res => {

                            // 如果valid等于0，表示该用户被禁用了，无法登录
                            if (res.data.result.enabled == 0) {
                                this.$alert('对不起，该账号已被禁用', '提示', {
                                    confirmButtonText: '确定'
                                })
                            } else {
                                me.$store.state.userId = res.data.result.id;
                                me.$store.state.name = res.data.result.name;
                                sessionStorage.setItem("tpid", this.$store.state.id);
                                sessionStorage.setItem("tpname", this.$store.state.name);
                                sessionStorage.setItem('tpuserId', this.$store.state.userId);
                                sessionStorage.setItem('tpshopid', this.$store.state.shopId);

                                // 存储用户名
                                sessionStorage.setItem("code", res.data.result.code);
                                // 存储身份证号
                                sessionStorage.setItem('idcard', res.data.result.idcard);

                                // 旧平台登录
                                // this.$post('users/member_login', {
                                //     token: me.$store.state.id,
                                //     memberCode: res.data.result.code,
                                //     password: sessionStorage.getItem('password')
                                // }).then(res => {
                                //     this.$store.state.oldUserData = JSON.parse(res.data.result.msg)
                                // })
                            }

                        }).then(() => {
                            // 用户被禁用就不让跳转
                            if (sessionStorage.getItem('tpid')) {
                                this.$post("shopping_cart/search", {
                                    token: this.$store.state.id,
                                    offset: "0",
                                    length: 9999,
                                    shop_id: this.shopId
                                }).then(res => {
                                    this.$store.state.shopNum = res.data.result.data.length;
                                    // this.$router.push({
                                    //     path: '/personalcenter',

                                    // })
                                });
                            }
                        });
                    } else if (res.data.errorMsg === '用户名或密码错误') {
                        me.loginMessage = '手机号或密码错误';
                        me.isLoginMessage = true;
                    }
                })
            }
        },
        //身份证登录
        login1: function() {
            let reg = /^\d{17}(\d|x|X)$/;
            let me = this;
            if (!me.loginIdentity.trim()) {
                me.loginMessage1 = '身份证号不能为空';
                me.isLoginMessage1 = true;
            } else if (!reg.test(me.loginIdentity)) {
                me.loginMessage1 = '身份证号格式错误';
                me.isLoginMessage1 = true;
            } else if (!me.loginPassword.trim()) {
                me.loginMessage1 = '密码不能为空';
                me.isLoginMessage1 = true;
            } else {
                // 存储用户
                sessionStorage.setItem('password', me.loginPassword);

                let obj = {
                    idcard: me.loginIdentity,
                    password: me.loginPassword,
                    shop_id: me.$store.state.store.id
                }
                me.$post('users/login_by_idcard', obj).then(res => {
                    if (res.data.result) {
                        me.$store.state.id = res.data.result.token;
                        me.$store.state.shopId = res.data.result.shop_id
                        let model = document.querySelector('#modal-center');
                        UIkit.modal(model).hide();
                        this.$post('users/profile', {
                            token: this.$store.state.id
                        }).then(res => {

                            // 如果valid等于0，表示该用户被禁用了，无法登录
                            if (res.data.result.enabled == 0) {
                                this.$alert('对不起，该账号已被禁用', '提示', {
                                    confirmButtonText: '确定'
                                })
                            } else {
                                me.$store.state.userId = res.data.result.id;
                                me.$store.state.name = res.data.result.name;
                                sessionStorage.setItem("tpid", this.$store.state.id);
                                sessionStorage.setItem("tpname", this.$store.state.name);
                                sessionStorage.setItem('tpuserId', this.$store.state.userId);
                                sessionStorage.setItem('tpshopid', this.$store.state.shopId);

                                // 存储用户名
                                sessionStorage.setItem("code", res.data.result.code);
                                // 存储身份证号
                                sessionStorage.setItem('idcard', res.data.result.idcard);


                                // 旧平台登录
                                // this.$post('users/member_login', {
                                //     token: me.$store.state.id,
                                //     memberCode: res.data.result.code,
                                //     password: sessionStorage.getItem('password')
                                // }).then(res => {
                                //     this.$store.state.oldUserData = JSON.parse(res.data.result.msg)
                                // })
                            }

                        }).then(() => {
                            // 用户被禁用就不让跳转
                            if (sessionStorage.getItem('tpid')) {
                                this.$post("shopping_cart/search", {
                                    token: this.$store.state.id,
                                    offset: "0",
                                    length: 9999,
                                    shop_id: this.shopId
                                }).then(res => {
                                    this.$store.state.shopNum = res.data.result.data.length;
                                    // this.$router.push({
                                    //     path: '/personalcenter',

                                    // })
                                });
                            }
                        });
                    } else if (res.data.errorMsg === '用户名或密码错误') {
                        me.loginMessage1 = '身份证号或密码错误';
                        me.isLoginMessage1 = true;
                    }
                })
            }
        },
        //用户名登录
        login2(loginName, password) {

            if (loginName && password) {
                this.loginName = loginName;
                this.loginPassword = password
            }


            let reg = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
            // let me = this;
            if (this.loginName.trim() == "") {
                this.loginMessage2 = '登录名不能为空';
                this.isLoginMessage2 = true;
            } else if (!this.loginPassword.trim()) {
                this.loginMessage2 = '密码不能为空';
                this.isLoginMessage2 = true;
            } else {
                // 存储用户密码
                sessionStorage.setItem('password', this.loginPassword);

                var obj = {
                    code: this.loginName,
                    password: this.loginPassword,
                    shop_id: this.shopId
                }

                this.$post('users/login', obj).then(res => {
                    if (res.data.result) {
                        this.$store.state.id = res.data.result.token;
                        this.$store.state.shopId = res.data.result.shop_id
                        let model = document.querySelector('#modal-center');
                        UIkit.modal(model).hide();
                        this.$post('users/profile', {
                            token: this.$store.state.id
                        }).then(res => {

                            // 如果valid等于0，表示该用户被禁用了，无法登录
                            if (res.data.result.enabled == 0) {
                                this.$alert('对不起，该账号已被禁用', '提示', {
                                    confirmButtonText: '确定'
                                })
                            } else {
                                this.$store.state.userId = res.data.result.id;
                                this.$store.state.name = res.data.result.name;
                                sessionStorage.setItem("tpid", this.$store.state.id);
                                sessionStorage.setItem("tpname", this.$store.state.name);
                                sessionStorage.setItem('tpuserId', this.$store.state.userId);
                                sessionStorage.setItem('tpshopid', this.$store.state.shopId);

                                // 存储用户名
                                sessionStorage.setItem("code", res.data.result.code);
                                // 存储身份证号
                                sessionStorage.setItem('idcard', res.data.result.idcard);

                                // 旧平台登录
                                // this.$post('users/member_login', {
                                //     token: this.$store.state.id,
                                //     memberCode: res.data.result.code,
                                //     password: sessionStorage.getItem('password')
                                // }).then(res => {
                                //     this.$store.state.oldUserData = JSON.parse(res.data.result.msg)
                                // })
                            }

                        }).then(() => {
                            // 用户被禁用就不让跳转
                            if (sessionStorage.getItem('tpid')) {
                                this.$post("shopping_cart/search", {
                                    token: this.$store.state.id,
                                    offset: "0",
                                    length: 9999,
                                    shop_id: this.shopId
                                }).then(res => {
                                    this.$store.state.shopNum = res.data.result.data.length;
                                    // this.$router.push({
                                    //     path: '/personalcenter',

                                    // })
                                });
                            }
                        });
                    } else if (res.data.errorMsg === '用户名或密码错误') {
                        this.loginMessage2 = '登录名或密码错误';
                        this.isLoginMessage2 = true;
                    }
                })
            }
        },


        //跳转去忘记密码页面
        wangjimima: function() {
            let model = document.querySelector('#modal-center');
            UIkit.modal(model).hide();
            this.$router.push({
                path: '/forgetpassword'
            });
        },
        //跳转去我的订单
        toMyOrder: function() {
            this.$router.push({
                path: '/myorder'
            });
        },
        //退出登录
        loginOut: function() {
            sessionStorage.removeItem("tpid");
            sessionStorage.removeItem("tpname");
            sessionStorage.removeItem("tpuserId");
            sessionStorage.removeItem("tpshopid");
            sessionStorage.removeItem('password');
            this.$store.state.id = null;
            this.$store.state.shopNum = 0;
            this.$store.state.userId = null;
            this.$router.push({
                path: '/'
            })
        },
        //登录时手机号输入框失去焦点
        loginPhoneBlur: function() {
            let reg = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
            let me = this;
            if (me.loginPhone.trim()) {
                if (reg.test(me.loginPhone)) {
                    me.isLoginMessage = false;
                } else {
                    me.loginMessage = '手机号格式错误',
                        me.isLoginMessage = true;
                }
            }
        },
        //登录时手机号输入框获取焦点
        loginPhoneFocus: function() {
            if (this.loginMessage === '手机号不能为空' || this.loginMessage === '手机号格式错误' || this.loginMessage ===
                '手机号或密码错误') {
                this.isLoginMessage = false;
            }
        },
        //登录时密码框获取焦点
        loginPasswordFocus: function() {
            if (this.loginMessage === '密码不能为空' || this.loginMessage === '手机号或密码错误') {
                this.isLoginMessage = false;
            }
        },
        //注册
        register: function() {
            if (!this.click) {
                //防抖
                this.click = 1;
                if (this.$store.state.store.agreement != '' && String(this.$store.state.store.agreement) !=
                    'undefined' && String(
                        this.$store.state.store.agreement) != 'null') {
                    if (this.agreeDoc != true) {
                        alert('必须同意用户协议才可注册!');
                        return false;
                    }
                }

                let reg = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
                let idcardReg =
                    /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9X]$/;
                let me = this;
                if (me.registerPhone && !reg.test(me.registerPhone)) {
                    me.registerMessage = '手机号格式错误';
                    me.isRegisterMessage = true;
                }
                // else if (!me.registerCode.trim()) {
                //     me.registerMessage = '验证码不能为空';
                //     me.isRegisterMessage = true;
                // } 
                else if (!me.registerName.trim()) {
                    me.registerMessage = '姓名不能为空';
                    me.isRegisterMessage = true;
                } else if (!me.idcard.trim()) {
                    me.registerMessage = '身份证不能为空';
                    me.isRegisterMessage = true;
                } else if (!idcardReg.test(me.idcard) || me.idcard.length !== 18) {
                    me.registerMessage = '身份证格式错误';
                    me.isRegisterMessage = true;
                } else if (!me.registerPassword.trim()) {
                    me.registerMessage = '密码不能为空';
                    me.isRegisterMessage = true;
                } else if (!me.registerAffirmPassword.trim()) {
                    me.registerMessage = '确认密码不能为空';
                    me.isRegisterMessage = true;
                } else if (me.registerPassword.trim() !== me.registerAffirmPassword.trim()) {
                    me.registerMessage = '两次密码不匹配';
                    me.isRegisterMessage = true;
                }
                 else if (!me.registerCompany.trim()) {
                    me.registerMessage = '工作单位不能为空';
                    me.isRegisterMessage = true;
                } 
                // else if (!me.registerGender.trim()) {
                //     me.registerMessage = '性别不能为空';
                //     me.isRegisterMessage = true;
                // } 
                else {
                    let obj = {
                        phone: this.registerPhone,
                        password: this.registerPassword,
                        idcard: this.idcard,
                        // code: this.registerCode,
                        // guid: this.guid,
                        // city: this.registerCity,
                        // gender: this.registerGender,
                        // province: this.registerProvince,
                        company: this.registerCompany,
                        name: this.registerName,
                        shop_id: this.shopId
                    }
                    this.$post('users/register', obj).then(res => {
                        if (res.data.result == '') {
                            let model = document.querySelector('#modal-center');
                            UIkit.modal(model).hide();
                            let modeltwo = document.querySelector('#modal-success-zhuce');
                            UIkit.modal(modeltwo).show();
                        } else if (res.data.result == '该用户已注册') {
                            this.registerMessage = '该用户已注册';
                            this.isRegisterMessage = true;
                        } else if (res.data.status == 'success') {
                            this.registerMessage = '注册成功！';
                            this.isRegisterMessage = true;
                            this.isEnter = !this.isEnter
                        }
                        // else if (res.data.result == '验证码错误') {
                        //     this.registerMessage = '验证码错误';
                        //     this.isRegisterMessage = true;
                        // }
                        // this.$post('users/member_register', {
                        //     memberCode: this.idcard,
                        //     idCard: this.idcard,
                        //     memberName: '默认用户名',
                        //     gender: '男',
                        //     password: this.registerPassword,
                        //     mobile: this.registerPhone,
                        //     province: '默认',
                        //     city: '默认',
                        //     shop_id: this.shopId
                        // })
                    })
                }
                setTimeout(() => {
                    this.click = 0
                }, 3000)
            }
        },
        //注册时手机号输入框失去焦点
        registerPhoneBlur: function() {
            let reg = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
            let me = this;
            if (me.registerPhone.trim()) {
                if (reg.test(me.registerPhone)) {
                    me.isRegisterMessage = false;
                } else {
                    me.registerMessage = '手机号格式错误',
                        me.isRegisterMessage = true;
                }
            }
        },
        //注册时手机号输入框获取焦点
        registerPhoneFocus: function() {
            if (this.registerMessage === '手机号不能为空' || this.registerMessage === '手机号格式错误' || this.registerMessage ===
                '该用户已注册') {
                this.isRegisterMessage = false;
            }
        },
        //注册身份证号输入框获取焦点
        registerIdFocus: function() {
            if (this.registerMessage === '身份证不能为空' || this.registerMessage === '该用户已注册' || this.registerMessage ===
                '身份证格式错误') {
                this.isRegisterMessage = false;
            }
        },
        //注册时验证码框获取焦点
        registerCodeFocus: function() {
            if (this.registerMessage === '验证码错误') {
                this.isRegisterMessage = false;
            }
        },
        //获取手机验证码
        getVerificationCode: function() {
            let me = this;
            let reg = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
            if (me.registerPhone.trim() == '') {
                this.registerMessage = '手机号不能为空';
                this.isRegisterMessage = true;
                return;
            } else if (!reg.test(me.registerPhone)) {
                me.registerMessage = '手机号格式错误';
                me.isRegisterMessage = true;
                return;
            } else {
                if (me.verificationText === '获取验证码') {
                    this.$post('users/sms_send', {
                        phone: this.registerPhone,
                        type: '注册',
                        shop_id: this.$store.state.store.id
                    }).then(res => {
                        this.guid = res.data.result;
                    })
                    let time = 60;
                    let timego = setInterval(function() {
                        me.verificationText = time + '秒后重发';
                        --time;
                        if (time < 0) {
                            clearInterval(timego);
                            me.verificationText = '获取验证码';
                        }
                    }, 1000);
                }
            }
        },
        //注册时密码框获取焦点
        registerPasswordFocus: function() {
            if (this.registerMessage === '密码不能为空' || this.registerMessage === '两次密码不匹配') {
                this.isRegisterMessage = false;
            }
        },
        //注册时密码框获取焦点
        registerCompanyFocus: function() {
            if (this.registerMessage === '工作单位不能为空') {
                this.isRegisterMessage = false;
            }
        },
        //注册时密码框获取焦点
        registerAffirmPasswordFocus: function() {
            if (this.registerMessage === '确认密码不能为空' || this.registerMessage === '两次密码不匹配') {
                this.isRegisterMessage = false;
            }
        },
        // 获取店铺信息
        getShopInfo() {
            this.$post('shops/get_shopid', {
                id: this.shopId
            }).then(res => {
                if (res.status === 200) {
                    this.is_project = res.data.result.is_project
                }
            })
        },

        toOld() {
            // 1. 验证用户是否登录
            if (this.verifyLogin()) {
                // 没有登录, 跳转弹窗登录框
                this.$router.push({
                    path: "/personalcenter"
                });
                return;
            }

            if (this.shopId == 107) {
                let password = sessionStorage.getItem('password');
                let code = sessionStorage.getItem('idcard');
                window.location.href =
                    `http://oldzzrc.ca163.net/study/login.jhtm?hehe=wutongyue&memberCode=${code}&password=${password}`;
            } else if (this.shopId == 110) {
                let password = sessionStorage.getItem('password');
                let code = sessionStorage.getItem('idcard');

                window.location.href =
                    `http://oldzzch.ca163.net/study/login.jhtm?hehe=wutongyue&memberCode=${code}&password=${password}`;
            }

        },

        // 验证用户是否登录
        verifyLogin() {
            return this.$isAbnormal(this.$store.state.id);
        },

        login3(loginName, password) {

            let href = window.location.href

            if (href.includes('memberCode')) {
                let arrUrl = href.split("?");
                let para = arrUrl[1];
                let arr = para.split('&');
                let obj = {};
                arr.map(res => {
                    let arrLin = res.split('=');
                    obj[arrLin[0]] = arrLin[1];
                })

                sessionStorage.setItem('password', password);

                this.$post('users/login', {
                    code: obj.memberCode,
                    password: obj.password,
                    shop_id: this.shopId
                }).then(res => {
                    if (res.data.result) {
                        this.$store.state.id = res.data.result.token;
                        this.$store.state.shopId = res.data.result.shop_id
                        let model = document.querySelector('#modal-center');
                        UIkit.modal(model).hide();
                        this.$post('users/profile', {
                            token: this.$store.state.id
                        }).then(res => {

                            // 如果valid等于0，表示该用户被禁用了，无法登录
                            if (res.data.result.enabled == 0) {
                                this.$alert('对不起，该账号已被禁用', '提示', {
                                    confirmButtonText: '确定'
                                })
                            } else {
                                this.$store.state.userId = res.data.result.id;
                                this.$store.state.name = res.data.result.name;
                                sessionStorage.setItem("tpid", this.$store.state.id);
                                sessionStorage.setItem("tpname", this.$store.state.name);
                                sessionStorage.setItem('tpuserId', this.$store.state.userId);
                                sessionStorage.setItem('tpshopid', this.$store.state.shopId);

                                // 存储用户名
                                sessionStorage.setItem("code", res.data.result.code);
                                // 存储身份证号
                                sessionStorage.setItem('idcard', res.data.result.idcard);

                                // 旧平台登录
                                // this.$post('users/member_login', {
                                //     token: this.$store.state.id,
                                //     memberCode: res.data.result.code,
                                //     password: sessionStorage.getItem('password')
                                // }).then(res => {
                                //     this.$store.state.oldUserData = JSON.parse(res.data.result.msg);
                                // })
                            }

                        }).then(() => {
                            // 用户被禁用就不让跳转
                            if (sessionStorage.getItem('tpid')) {
                                this.$post("shopping_cart/search", {
                                    token: this.$store.state.id,
                                    offset: "0",
                                    length: 9999,
                                    shop_id: this.shopId
                                }).then(res => {
                                    this.$store.state.shopNum = res.data.result.data.length;
                                    // this.$router.push({
                                    //     path: '/personalcenter',

                                    // })
                                });
                            }
                        });
                    } else if (res.data.errorMsg === '用户名或密码错误') {
                        this.loginMessage2 = '登录名或密码错误';
                        this.isLoginMessage2 = true;
                    }
                });
            }

        },

        // 获取店铺id
        getShopId() {

   //          // 线上 start
   //          let url = "";
   //          let hostName = window.location.hostname;
   //          // 指向人才
   //          let belongToZZRC = `
			// jxjy.zzrc.cn,
			// http://zzrc-uat.ca163.net.cn,
			// http://zzrc.ca163.net,
			// https://zzrc.ca163.net,
			// zzrc-uat.ca163.com`;
   //          if (belongToZZRC.includes(hostName)) {
   //              url = "http://zzrc.ca163.net";
   //          } else {
   //              url = window.location.origin;
   //          }
   //          // 指向畅和
   //          let belongToZZCH = `zzch-uat.ca163.net.cn,
			// zzch.ca163.net,
			// zzch-uat.ca163.com,
			// http://jxjy.zzzjedu.com`;
   //          if (belongToZZCH.includes(hostName)) {
   //              url = "http://zzch-test.ca163.net";
   //          } else {
   //              url = window.location.origin;
   //          }
   //          // 线上 end

            // 本地测试
            let url = this.testUrl; //

            this.$post("shops/get", {
                url: url
            }).then(res => {
                this.shopId = res.data.result.id;

                this.shopId == 110 ? this.activeName = 'second' : this.activeName = 'first';

                this.getShopInfo();

                this.login3();
            });
        }

    },

    //DOM加载完毕执行
    mounted: function() {

        let model = document.querySelector('#modal-example-1');
        let me = this;
        UIkit.util.on(model, 'hidden', function() {
            me.toLogin();
        });
        // setTimeout(res=>{
        // me.login3();
        // },1000);


    },

    created() {
        this.getShopId();
    },

    components: {
        MainPage,
    }
}
